import React from 'react'

import { useTranslation } from 'react-i18next'

import LoadingSpinner from '@components/shared/LoadingSpinner'

const PurchasingSpinner: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="absolute top-0 bottom-0 left-0 right-0 z-10 bg-white dark:bg-black bg-opacity-90">
      <div className="relative text-center top-1/2 translate-y-[-50%]">
        <LoadingSpinner />
        <p className="text-lg dark:gray-text">{t('action.purchasing')}</p>
      </div>
    </div>
  )
}

export default PurchasingSpinner
